<template>
  <div class="media">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VMedia',
};
</script>

<style lang="scss">
.media {
  & > * {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
